import { getCategories } from "../../../api/divvy-category";

const divvyCategory = {
  namespaced: true,
  state: () => ({
    categories: [],
    categoriesOne: [],
    categoriesTwo: [],
  }),

  getters: {
    allCategories: (state) => state.categories,
    allCategoriesOne: (state) => state.categoriesOne,
    allCategoriesTwo: (state) => state.categoriesTwo,
  },

  actions: {
    fetchCategories({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCategories(params)
          .then((data) => {
            console.log(data, "from getCategories");
            commit("SET_CATEGORIES", data);
            resolve(data);
          })
          .catch((err) => {
            console.log(err, "from getCategories");
          });
      });
    },
    fetchSubCategoriesOne({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCategories(params)
          .then((data) => {
            console.log(data, "from getCategoriesOne");
            commit("SET_CATEGORIES_ONE", data);
            resolve(data);
          })
          .catch((err) => {
            console.log(err, "from getCategoriesOne");
          });
      });
    },
    fetchSubCategoriesTwo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCategories(params)
          .then((data) => {
            console.log(data, "from getCategoriesTwo");
            commit("SET_CATEGORIES_TWO", data);
            resolve(data);
          })
          .catch((err) => {
            console.log(err, "from getCategoriesTwo");
          });
      });
    },
  },

  mutations: {
    SET_CATEGORIES: (state, data) => {
      state.categories = data.categories;
    },
    SET_CATEGORIES_ONE: (state, data) => {
      state.categoriesOne = data.categories;
    },
    SET_CATEGORIES_TWO: (state, data) => {
      state.categoriesTwo = data.categories;
    },
  },
};

export default divvyCategory;
